// extracted by mini-css-extract-plugin
export default {"ReferralLinks_title-text":"referralLinks_ReferralLinks_title-text__NTLMG","ref-link":"referralLinks_ref-link__fb-4c"};